import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jforloop(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
  <Sides/>
  <Helmet>
 
  <title>Master the Art of Java For Loop: A Beginner's Tutorial Guide by CodeExampler</title>
<meta name="description" content="Java forloop tutorial for beginners.The body of the Java for loop must be executed until the given condition is false." />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java for loop,java for loop with,java for loop example,java for loop array,java for loop syntax,java for loop break,java for loop list,java for loop exit,java for loop for list
,java for loop iterator,leap year java,java for loop continue,java for loop arraylist,java for loop exercises,continue in java for loop,java for loop next,java for loop colon,java stream vs for loop,java for loop programs,java for loop string array,java for loop index
,java for loop tutorial,java for loop collection,java for loop practice,java for loop user input
" />
<link rel="canonical" href="https://www.codeexampler.com/java-for-loop" />
</Helmet>

<div className='lg:pl-56'>

   <h1 className="m-4 mh1">For Loop Java</h1>
   <div className="first">
        <a href="/java-do-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-break">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<h2 className="mt-4 mh2">Java for loop program
</h2>
<p className="mt-4 para">1, The body of the Java for loop must be executed until the given condition is false<br/>
2, The for loop Java Program semicolon must be used <br/>
3, This for loop in Java is used to repeat a particular piece of code for a fixed no of times<br/>

</p>



<h2 className="headings">Java for loop Syntax:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
      
      {"\n"}
  <span className="qwerty-10">for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">initialization;</span>
  <span className="qwerty-10">condition;</span>
  <span className="qwerty-8">iteration</span>
  <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-4">&nbsp;&nbsp;Statement sequence </span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&#125; </span>
  {"\n"}

        </code>
      </pre>        
    </div>

<h2 className="mt-4 mh2">For loop in Java Program Example</h2>


<h2 className="headings">Q-Write a Program to print a number from 1 to 10 in java for loop?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> Forloop_example</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
  

          
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">i;</span>
      
      {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">i</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">1;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">&#60;</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">10;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">++</span>     
  <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>

  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"Loop Start: "</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">i</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}

 
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;Loop Start:</span> 
          <span className="qwerty-5">&nbsp;1 </span>                   
          {"\n"}
          <span className="qwerty-3">&nbsp;Loop Start:</span><span className="qwerty-5">&nbsp;2 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Loop Start:</span><span className="qwerty-5">&nbsp;3 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Loop Start:</span><span className="qwerty-5">&nbsp;4 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Loop Start:</span><span className="qwerty-5">&nbsp;5 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Loop Start:</span><span className="qwerty-5">&nbsp;6 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Loop Start:</span><span className="qwerty-5">&nbsp;7 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Loop Start:</span><span className="qwerty-5">&nbsp;8 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Loop Start:</span><span className="qwerty-5">&nbsp;9 </span>    
          {"\n"}
          <span className="qwerty-3">&nbsp;Loop Start:</span><span className="qwerty-5">&nbsp;10 </span>
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>


<h2 className="headings">Q-Write a Program loop starts from 1 to 10 but print from 2 to 11 in Java for loop Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> Forloop_example</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
  

          
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">i;</span>
      
      {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">i</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">1;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">&#60;</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">10;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">++</span>     
  <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}

 


 
 


          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-5">&nbsp;1 </span>  
          {"\n"}  
          <span className="qwerty-5">&nbsp;2 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;3 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;4 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;5 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;6 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;7 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;8 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;9 </span>    
          {"\n"}
          <span className="qwerty-5">&nbsp;10 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;11 </span>
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>




<h2 className="headings">Q-Write a Program to print a name after Program is complete in Java for loop Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> Forloop_example</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
  

          
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">i;</span>
      
      {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">i</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">1;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">&#60;</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">10;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">++</span>     
  <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"Code Exampler"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}

 


 
 


          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-5">&nbsp;1 </span>  
          {"\n"}  
          <span className="qwerty-5">&nbsp;2 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;3 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;4 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;5 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;6 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;7 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;8 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;9 </span>    
          {"\n"}
          <span className="qwerty-5">&nbsp;10 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Code Exampler  </span>
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>




<h2 className="headings">Q-Write a Program to print a name again and again in Java for loop Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> Forloop_example</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
  

          
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">i;</span>
      
      {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">i</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">1;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">&#60;</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">10;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">++</span>     
  <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"Ram Ram"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}

 
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-5">&nbsp;1 </span>  
          {"\n"}                 
          <span className="qwerty-3">&nbsp;Ram Ram </span> 
          {"\n"}
          <span className="qwerty-5">&nbsp;2 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Ram Ram </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;3 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Ram Ram </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;4 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Ram Ram </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;5 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Ram Ram </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;6 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Ram Ram </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;7 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Ram Ram </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;8 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Ram Ram </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;9 </span>    
          {"\n"}
          <span className="qwerty-3">&nbsp;Ram Ram</span> 
          {"\n"}
          <span className="qwerty-5">&nbsp;10 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Ram Ram </span>
          {"\n"}
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>



<h2 className="headings">Q-Write a Program to combine a no and name in Java for loop Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> Forloop_example</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
  

          
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">i;</span>
      
      {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">i</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">1;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">&#60;</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">10;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">++</span>     
  <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>

  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"Hello Ram"</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">i</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}

 


 
 


          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello Ram </span> 
          <span className="qwerty-5">&nbsp;1 </span>                   
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello Ram </span><span className="qwerty-5">&nbsp;2 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello Ram </span><span className="qwerty-5">&nbsp;3 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello Ram </span><span className="qwerty-5">&nbsp;4 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello Ram </span><span className="qwerty-5">&nbsp;5 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello Ram </span><span className="qwerty-5">&nbsp;6 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello Ram </span><span className="qwerty-5">&nbsp;7 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello Ram </span><span className="qwerty-5">&nbsp;8 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello Ram</span> <span className="qwerty-5">&nbsp;9 </span>    
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello Ram </span><span className="qwerty-5">&nbsp;10 </span>
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>



<h2 className="headings">Q-Write a Program to fabonacci series in Java for loop Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> fabicono_series</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
  

          
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">0 ,</span>
      <span className="qwerty-4">b</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">1 ,</span>
      <span className="qwerty-4">c</span>
      <span className="qwerty-1"> ,</span>
      <span className="qwerty-4">i;</span>
      {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">i</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">1;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">&#60;</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">10;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">++</span>     
  <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>

  {"\n"}
  <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;c</span>
      <span className="qwerty-8"> = </span>
  <span className="qwerty-4">a</span>
  <span className="qwerty-8"> + </span>
      <span className="qwerty-4">b ;</span>
 

  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">c</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-4">b ;</span>
      {"\n"}
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;b</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-4">c ;</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
  
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp; &#125; </span>
 
{"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
     </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;1 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;2 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;3 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;5 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;8 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;13 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;21 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;34 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;55 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;89 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;3 </span>
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>

  <h1 className="mt-5">  </h1>
   
  <div className="back">
        <a href="/java-do-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-break">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Jforloop;